// extracted by mini-css-extract-plugin
export default {"resultsWrapper":"GameResults_resultsWrapper__dctVO"};